import { useCallback, useEffect, useMemo } from "react";
import TableWidget from "../../../components/tables/TableWidget";
import {
  fetchAwbHistory,
  getAwbStatuses,
} from "../../../redux/api/expedition.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import {
  awbHistoryTableHeader,
  getAwbTableData,
} from "./tableConfigs/awbHistoryTableConfig";
import AwbHistoryActionButtons from "./ActionButtons/AwbHistoryActionButtons";
import { fetchRoutesNomenclatures } from "../../../redux/api/transport.api";
import CustomButton from "../../../components/CustomButton";
import useTableCtx from "../../../components/tables/tableContext/useTableCtx";
import RouteTransferActiveExpeditionModal from "./RouteTransferActiveExpeditionModal";
import { setClientsSelectedActiveExpedition } from "../../../redux/reducer/expedition.reducer";
import { KTSVG } from "../../../helpers/KTSVG";

function AwbHistoryTable() {
  const dispatch = useAppDispatch();
  const {
    expedition: {
      awbHistory: {
        data: { data: dataAwb, total: totalAwb },
        isLoading: isLoadingAwb,
      },
      workingRoutesNodes: {
        data: { data: clientsNodesData },
      },
      clients: { data: clientsData },
      awbStatuses: { data: awbStatusesData, isLoading: isLoadingAwbStatus },
    },
    transport: {
      routesNomenclatures: {
        data: { data: routesNomenclatures },
        isLoading: isLoadingRoutesNomenclatures,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
    transport: state.transport,
  }));

  useEffect(() => {
    dispatch(getAwbStatuses());

    dispatch(
      fetchRoutesNomenclatures({
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const CustomHeaderComponent = () => {
    const { selectedItems } = useTableCtx() || {};

    const handleSetSelectedClient = () => {
      if (selectedItems) {
        dispatch(setClientsSelectedActiveExpedition(selectedItems));
      }
    };

    return (
      <div className="mb-5 d-flex justify-content-between align-items-center">
        <div className="mb-14" />

        <div>
          {selectedItems && selectedItems.length > 0 && (
            <CustomButton
              variant="contained"
              className="mt-1 me-1"
              tooltipTitle="Transfer ruta"
              onClick={handleSetSelectedClient}>
              <KTSVG
                path="/media/svg/expedition/route.svg"
                className="svg-icon-1"
                fill="white"
              />
            </CustomButton>
          )}
        </div>
      </div>
    );
  };

  const getHistoryTableHeaderNew = useCallback(
    (initialTableData: any[]) => {
      return initialTableData.map((item) => {
        if (item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (item.value === "client") {
          const clientsDropdown = clientsData?.data.map(
            ({ denumireClient, idClient }) => ({
              label: denumireClient,
              value: idClient || 0,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: "all" }, ...clientsDropdown],
            ...item,
          };
        }
        if (!isLoadingAwbStatus && item.value === "status") {
          const awbStatusesDropdown = awbStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...awbStatusesDropdown,
            ],
            ...item,
          };
        }
        if (!isLoadingRoutesNomenclatures && item.value === "route") {
          const routesDropdown = routesNomenclatures?.map(
            ({ denumire, id_ruta }) => ({
              label: denumire,
              value: id_ruta,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...routesDropdown],
            ...item,
          };
        }

        return item;
      });
    },
    [
      awbStatusesData,
      clientsData?.data,
      clientsNodesData,
      isLoadingAwbStatus,
      isLoadingRoutesNomenclatures,
      routesNomenclatures,
    ],
  );

  const handleAwbTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter &&
      action.tableFilter.client
    ) {
      dispatch(
        fetchAwbHistory({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          id_client: action.tableFilter.client,
          pctlivrare: action.tableSearch.pctlivrare,
          nodDestinatie: action.tableFilter.nodDestinatie,
          status: action.tableFilter.status,
          doc_trans: action.tableSearch.doc_trans,
          route: action.tableFilter.route,
          coldFilter: action.tableFilter.coldFilter,
        }),
      );
    }
  };

  const awbHistoryTableHeaderNew = useMemo(
    () => getHistoryTableHeaderNew(awbHistoryTableHeader),
    [getHistoryTableHeaderNew],
  );

  return (
    <>
      <RouteTransferActiveExpeditionModal />
      <TableWidget
        CustomHeaderComponent={CustomHeaderComponent}
        tableHeaderData={awbHistoryTableHeaderNew}
        tableItemsData={getAwbTableData(dataAwb)}
        totalItems={totalAwb}
        tableLoading={isLoadingAwb}
        handleTableActions={handleAwbTableActions}
        ActionButtonsComponent={(props: any) => (
          <AwbHistoryActionButtons {...props} />
        )}
        borderedRow
      />
    </>
  );
}

export default AwbHistoryTable;
